import PropTypes from 'prop-types'
import { Input } from '../../../common/html/input'
import classes from '../../index.module.scss'

export const InputUserProfile = ({
  value,
  title,
  containerStyle,
  isShowLabel,
  onChange,
  isValid,
  textInvalid,
  disabled,
  defaultValue,
  inputKey,
  styleTextInvalid,
}) => {
  return (
    <div className={classes.inputForm} key={inputKey}>
      <Input
        isShowLabel={isShowLabel}
        placeHolder={title}
        containerStyle={{ ...containerStyle }}
        onChange={onChange}
        isValid={isValid}
        textInvalid={textInvalid}
        disabled={disabled}
        defaultValue={defaultValue}
        value={value || ''}
        isShowIcon={false}
        styleTextInvalid={styleTextInvalid}
        styleLabel={{ backgroundColor: '#FFFFFF' }}
        noControl
      />
    </div>
  )
}

InputUserProfile.defaultProps = {
  placeHolder: PropTypes.string,
  isShowLabel: PropTypes.bool,
  containerStyle: PropTypes.object,
}

InputUserProfile.defaultProps = {
  placeHolder: '',
  isShowLabel: true,
  containerStyle: {},
}
